//
// TextElement.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./VisualElement";
import "../dataDefinition/DataDefinition";
import "../common/text/ParagraphElement";
import "./TextMissingValueDisplay";

var TextElement = createModule("BIRD::TextElement", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::VisualElement"], EventDispatcher, [
    ,
    {
        textStyleClass: 7,
        missingValueDisplay: 4,
        primaryDataDefinition: 1,
        paragraphs: [1],
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default TextElement;
